module.exports = __webpack_public_path__ + "static/dave-connell-e6d2bec2d3e651a468097a8c4d0bab74.jpg";